import React from "react";
import Skeleton from "react-loading-skeleton";

function TopSaleSkeleton() {
  return (
    <div className="w-full flex justify-evenly gap-10  pb-5">
      <div className="mt-7">
        <Skeleton
          height={300}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
        />
      </div>
      <div className="mt-7">
        <Skeleton
          height={300}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
        />
      </div>
      <div className="mt-7">
        <Skeleton
          height={300}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
        />
      </div>
      <div className="mt-7">
        <Skeleton
          height={300}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
        />
      </div>
      <div className="mt-7">
        <Skeleton
          height={300}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
        />
      </div>
    </div>
  );
}

export default TopSaleSkeleton;
